/* eslint-disable */
export default {
  forward: '转接',
  cancel: '取消',
  customNumber: '自定义号码',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
